export default "__VITE_ASSET__DTcTS1vD__"